export function formatDate(time, str = 'yyyy-MM-dd hh:mm') {
    var date = new Date(time);
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    var hour = date.getHours();
    var mm = date.getMinutes()
    var ss = date.getSeconds()
    if (month >= 1 && month <= 9) month = "0" + month;
    if (strDate >= 0 && strDate <= 9) strDate = "0" + strDate;
    if (hour >= 0 && hour <= 9) hour = "0" + hour;
    if (mm >= 0 && mm <= 9) mm = "0" + mm;
    if (ss >= 0 && ss <= 9) ss = "0" + ss;
    var strDateTime = str
    if (str.indexOf('yyyy') > -1) strDateTime = strDateTime.replace("yyyy", date.getFullYear())
    if (str.indexOf('MM') > -1) strDateTime = strDateTime.replace('MM', month)
    if (str.indexOf('dd') > -1) strDateTime = strDateTime.replace('dd', strDate)
    if (str.indexOf('hh') > -1) strDateTime = strDateTime.replace('hh', hour)
    if (str.indexOf('mm') > -1) strDateTime = strDateTime.replace('mm', mm)
    if (str.indexOf('ss') > -1) strDateTime = strDateTime.replace('ss', ss)
    return strDateTime;
}